import React from "react";
import ReactApexChart from "react-apexcharts";

const ColumnWithNegativeVal = ({
  title,
  categories,
  seriesData,
  colors,
  seriesName,
}) => {
  const labelColors = categories.map((cat, idx) => {
    if (cat === "YOY Change") {
      const val = seriesData[idx];
      if (val === 0) {
        return "#333";
      }
      return "#fff";
    }
    return "#333";
  });

  // Process data so 0% has a tiny bar height of 1.5% to visually indicate the value
  const processedSeriesData = seriesData.map((val) => {
    if (val === 0) {
      return 1.5;
    }
    return val;
  });

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        columnWidth: "40%", // Default, overridden on small screens
        dataLabels: {
          position: "top",
        },
      },
    },
    colors,
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: "12px",
        fontWeight: "normal",
        colors: ["#333"],
      },
      formatter: function (val, opts) {
        const idx = opts?.dataPointIndex;
        const originalVal =
          seriesData && idx !== undefined ? seriesData[idx] : val;
        if (originalVal === null || originalVal === undefined) return "";
        const formattedVal = `${parseFloat(originalVal.toFixed(2))}%`;
        const category =
          categories && idx !== undefined ? categories[idx] : null;
        if (category === "YOY Change") {
          return `${formattedVal} - YOY Change`;
        }
        return formattedVal;
      },
    },
    yaxis: {
      axisBorder: {
        show: true,
        color: "#000",
      },
      axisTicks: {
        show: true,
        color: "#000",
      },
      min: -100,
      max: 100,
      tickAmount: 10,
      labels: {
        formatter: (y) => `${y}%`,
        style: {
          fontSize: "12px",
        },
      },
    },
    xaxis: {
      categories,
      labels: {
        show: !categories.includes("YOY Change"),
        style: {
          fontSize: "12px",
          colors: labelColors,
        },
      },
      axisBorder: { show: true },
      axisTicks: { show: true },
      position: "bottom",
      floating: true,
      offsetY: -160,
    },
    tooltip: {
      y: {
        formatter: function (val, opts) {
          const idx = opts?.dataPointIndex;
          const originalVal =
            seriesData && idx !== undefined ? seriesData[idx] : val;
          if (originalVal === null || originalVal === undefined) return "";
          return `${parseFloat(originalVal.toFixed(2))}%`;
        },
      },
    },
    responsive: [
      {
        breakpoint: 1024, // Tablets
        options: {
          plotOptions: {
            bar: {
              columnWidth: "50%",
            },
          },
          xaxis: {
            offsetY: -160,
            labels: {
              show: !categories.includes("YOY Change"),
              style: { fontSize: "11px", colors: labelColors },
            },
          },
        },
      },
      {
        breakpoint: 768, // Mobile
        options: {
          plotOptions: {
            bar: {
              columnWidth: "60%",
            },
          },
          chart: {
            height: 300,
          },
          xaxis: {
            offsetY: -135,
            labels: {
              show: !categories.includes("YOY Change"),
              style: { fontSize: "10px", colors: labelColors },
            },
          },
          yaxis: {
            labels: {
              style: {
                fontSize: "10px",
              },
            },
          },
        },
      },
    ],
  };

  return (
    <div className="w-full max-w-full overflow-x-auto px-2 sm:px-4">
      <div className="min-w-[350px]">
        <ReactApexChart
          options={chartOptions}
          series={[{ name: seriesName || "Change", data: processedSeriesData }]}
          type="bar"
          height={350}
        />
        <p className="text-center font-medium mt-2 text-sm md:text-base">
          {title}
        </p>
      </div>
    </div>
  );
};

export default ColumnWithNegativeVal;
